import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    variationsProcessing: string;
    viewFolder: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** This text describes assets on which Firefly actions were applied and their variations are being generated. */
            variationsProcessing: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useVariationsProcessingToast.variationsProcessing?c=3p4c854k3e6e1", defaultMessage: "Variations are being processed" }));
                },
                enumerable: true,
                configurable: true
            },
            /** This button is used to navigate to the folder and also see the notes. */
            viewFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useVariationsProcessingToast.viewFolder?c=b1dxo8hzajsp", defaultMessage: "View folder and Notes" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
